import React from 'react';
import { Box } from '@material-ui/core';

import { useTranslation } from 'hooks/useTranslation';
import { getBalanceCurrencyId, saveBalanceCurrencyId } from 'utils/localStorage';

import type { BalanceCurrency } from 'features/app/ts/BalanceCurrency';
import { usePartnerBalanceQuery } from 'features/app/hooks/usePartnerBalanceQuery';
import BaseBalanceDropdown from 'features/app/components/BaseBalanceDropdown';
import { useStyles } from 'features/app/components/BalanceDropdown/styles';

export const BalanceDropdown: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('app');

  const { data } = usePartnerBalanceQuery();

  const [displayedBalanceId, setDisplayedBalanceId] = React.useState(() => getBalanceCurrencyId());

  const displayedBalance = React.useMemo(
    () => data?.find(item => item.id === displayedBalanceId) ?? data?.[0],
    [displayedBalanceId, data]
  );

  const items = React.useMemo(
    () => (data ? data.filter(item => item.id !== displayedBalance?.id) : []),
    [data, displayedBalance]
  );

  const createCurrencyChangeHandler = React.useCallback((item: BalanceCurrency) => {
    setDisplayedBalanceId(item.id);
    saveBalanceCurrencyId(item.id);
  }, []);

  return (
    <Box className={classes.dropdownContainer}>
      <BaseBalanceDropdown
        options={items}
        displayedBalance={displayedBalance}
        onChange={createCurrencyChangeHandler}
        title={t('balance')}
      />
    </Box>
  );
};
